<label>Channels</label>
<ng-select
  class="channel-box"
  [items]="channels"
  bindValue="id"
  bindLabel="label"
  [(ngModel)]="value"
  (change)="onChange()"
  [multiple]="options.multi"
  [loading]="channelSvc.gettingRecords"
>
</ng-select>
<!-- <ng-container *ngIf="options.multi">
  <ng-select
    class="channel-box"
    [items]="_channels | async"
    bindValue="id"
    bindLabel="label"
    [(ngModel)]="value"
    (change)="onChange()"
    [multiple]="true"
    [loading]="channelSvc.gettingRecords"
  >
  </ng-select>
</ng-container>
<ng-container *ngIf="!options.multi">
  <select class="form-control" [(ngModel)]="value" (ngModelChange)="onChange()">
    <option value="0">All</option>
    <option value="-1">Luminous Invoices</option>
    <option *ngFor="let c of channels" [value]="c.id">
      {{ c.label }}
    </option>
  </select>
</ng-container> -->
